import {User} from "../../../services/UsersService";
import {BaseState} from "../../BaseState";

export enum Tab {
  general = "general",
  billing = "billing",
  counters = "counters",
  settings = "settings",
  actions = "actions",
  loginUsers = "loginUsers",
  ignoredUrls = "ignoredUrls",
  sso = "sso"
}

export interface UserState extends BaseState {
  originalUser: User | null;
  user: User | null;
  grantsHeldAtLoad: readonly string[];
  activeTab: Tab;
}
